export const InitiatedBookingActionTypes = {
  INITIATED_BOOKING_LIST_GET: 'INITIATED_BOOKING_LIST_GET',
  INITIATED_BOOKING_LIST_GET_SUCCESSFUL: 'INITIATED_BOOKING_LIST_GET_SUCCESSFUL',
  INITIATED_BOOKING_LIST_GET_ERROR: 'INITIATED_BOOKING_LIST_GET_ERROR',

  SET_INITIATED_BOOKING_QUERY: 'SET_INITIATED_BOOKING_QUERY',
  RESET_INITIATED_BOOKING_QUERY: 'RESET_INITIATED_BOOKING_QUERY'
}
